import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSetAtom } from "jotai";
import { useCanShop } from "@/hooks/useCanShop";
import { useShoppingCartApi } from "@/hooks/apiHooks/useShoppingCartApi";
import { CustomerNavigation } from "./HeaderFooter/CustomerNavigation/CustomerNavigation";
import { Footer } from "./HeaderFooter/footer";
import { SearchPanel } from "./Search/SearchPanel";
import { isSearchPanelOpenAtom } from "./Search/store/searchAtoms";

export const CustomerContainer = () => {
    const canShop = useCanShop();
    const setSearchPanelOpen = useSetAtom(isSearchPanelOpenAtom);

    // The panel reads GET /categories and product suggest, both walled to
    // active customers (#416), so it exists only for a shopper who can shop:
    // losing that (signing out here or in another tab) unmounts it mid-flight. The open
    // flag is cleared too, or the panel would re-open by itself on the next
    // sign-in.
    useEffect(() => {
        if (!canShop) setSearchPanelOpen(false);
    }, [canShop, setSearchPanelOpen]);

    // The header's cart badge reads the cart atom, which only the cart pages
    // filled, so a fresh load showed no count (B-15). GET /shoppingcarts is
    // walled to active customers, so it is read only for a shopper who can
    // shop — the rule the header's Cart link is shown by — and read again on a
    // destination switch (getShoppingCart's identity follows it). A page that
    // reads the cart in the same moment shares this request (getShoppingCart
    // dedupes). The badge has no failed state of its own: a failed read leaves
    // the atom as it was (no count on a fresh load, never a wrong one), and it
    // raises no toast — a cart nobody opened has no context on /c/account or
    // /c/browse. The Cart and Checkout show their own failed state.
    const { getShoppingCart } = useShoppingCartApi();
    useEffect(() => {
        if (!canShop) return;
        getShoppingCart({ skipErrorNotification: true }).catch(() => {
            /* see above */
        });
    }, [canShop, getShoppingCart]);

    return (
        <div className="min-h-screen flex flex-col bg-base-200">
            <CustomerNavigation />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            {canShop && <SearchPanel />}
        </div>
    );
};
